import React from 'react'
import { thankYouCalender, thankYouImage } from '../../../images/images';
import './ThankYouPage.css';

function ThankYouPage(props) {
    // const okButton = () => {
    //     window.open("about:blank", "_self");

    // }

    const {
        customerMobNum,
        customerEmail,
        isRenewalViaDirectDebit
    } = props.thankYouPageProps

    return (
        <>
            <div className='cd-thnku-container' >
                <div className='thnk-you-container'>
                    <div className='cd-thnku-image'>
                        <img src={thankYouImage} alt="thankYou" />
                    </div>
                    <div className='Thank-you-text'>
                        <p>Thanks for the payment</p>
                    </div>
                    <div className='otp-success-text'>
                        <p>Your Debit with renewal request has been submitted successfully.</p>
                    </div>
                    <div className='personal-detail-text'>
                        <p>We will keep you posted on {customerEmail} & xxxxxxx{customerMobNum}</p>
                    </div>
                    <div className='link-container'>
                        <div className='image-calender'>
                            <img src={thankYouCalender} alt="thankYouCalender" />
                        </div>
                        {
                            isRenewalViaDirectDebit ?
                                <>
                                    <p className='link-text'> To change the date of debit with renewal,<br /> Please login to your account at
                                        <a href='https://www.axismaxlife.com/' class="text-style-1"> www.axismaxlife.com</a></p>
                                </>
                                :
                                <>
                                    <p className='link-text'> To change the date of debit, <br /> Please login to your account at
                                        <a href='https://www.axismaxlife.com/' class="text-style-1"> www.axismaxlife.com</a></p>
                                </>
                        }
                    </div>

                </div>
            </div>
        </>
    )
}

export default ThankYouPage